import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useHideDashboardLeft = (): IGlobalStore['hideDashboardLeft'] => {
  return useSelector((store: IReducerStore) => store.global.hideDashboardLeft);
};
